<div class="wizard-step">
    <ng-content *ngIf="active"></ng-content>
</div>